import request from '@/utils/request'

// 查询各平台产品属性信息1)业务定义： 产品目录子类，所应对应的属性信息列表
export function listAttr(query) {
  return request({
    url: '/platform/attr/list',
    method: 'get',
    params: query
  })
}

// 查询各平台产品属性信息1)业务定义： 产品目录子类，所应对应的属性信息详细
export function getAttr(attrId) {
  return request({
    url: '/platform/attr/' + attrId,
    method: 'get'
  })
}

// 新增各平台产品属性信息1)业务定义： 产品目录子类，所应对应的属性信息
export function addAttr(data) {
  return request({
    url: '/platform/attr',
    method: 'post',
    data: data
  })
}

// 修改各平台产品属性信息1)业务定义： 产品目录子类，所应对应的属性信息
export function updateAttr(data) {
  return request({
    url: '/platform/attr',
    method: 'put',
    data: data
  })
}

// 删除各平台产品属性信息1)业务定义： 产品目录子类，所应对应的属性信息
export function delAttr(attrId) {
  return request({
    url: '/platform/attr/' + attrId,
    method: 'delete'
  })
}

// 导出各平台产品属性信息1)业务定义： 产品目录子类，所应对应的属性信息
export function exportAttr(query) {
  return request({
    url: '/platform/attr/export',
    method: 'get',
    params: query
  })
}

//通过CatId查找集合
export function getListByCatId(params) {
    return request({
        url: '/platform/attr/getListByCatId',
        method: 'get',
        params: params
    })
}

//获取公共的变种主题
export function getPublicAttr(){
    return request({
        url: '/platform/attr/getPublicAttr',
        method: 'get',

    })
}

//查询类目ID为00的shopee固定属性名Id
export function getSPlatAttrId(param){
    return request({
        url: '/platform/attr/getSPlatAttrId',
        method: 'get',
        params:param,

    })
}

//通过catId获取变种属性值集合
export function getBzztAttrListByCatId(params) {
    return request({
        url: '/platform/attr/getBzztAttrListByCatId',
        method: 'get',
        params: params
    })
}
